<template>
  <div>
    <Navbar />

    <section class="category-page">
      <Header
        :formData="formData"
        :insuranceType="insuranceType"
        formID="get-offer-motor-insurance"
      />
      <get-quote :quoteCard="quoteCard" />
      <category-info :categoryInfo="categoryInfo" />
      <get-price-section
        :getPrice="getPrice"
        :getPriceContent="getPriceContent"
      />
      <Tables />
      <app-contracted-insurance-companies :buttons="buttonData" />
      <frequently-asked-questions
        :faqTitle="faqTitle"
        :faqTitleDesc="faqTitleDesc"
        :questions="questions"
      />
    </section>
    <Footer />
  </div>
</template>

<script>
import Navbar from '@/component/navbar/Navbar'
import Header from '@/component/categories/Header'
import GetQuote from '@/component/categories/GetQuote'
import categoryInfo from '@/component/categories/CategoryInfo'
import getPriceSection from '@/component/categories/GetPriceSection'
import appContractedInsuranceCompanies from '@/component/contracted-insurance-companies/AppContractedInsuranceCompanies'
import frequentlyAskedQuestions from '@/component/expansional-question-panel/AppQuestionPanel'
import MotorInsuranceData from '@/data/category-page-data/MotorInsurance'
import Footer from '@/component/footer/Footer'
import QuotationType from '@/data/QuotationType'
import Tables from '@/views/category-pages/motor-insurance/Tables'
import { filteredButtons } from '@/mixins/FilteredButtons'

export default {
  metaInfo: {
    title: 'En Uygun Araç Kasko Sigortası Fiyatları İçin Teklif Alın',
    meta: [
      {
        name: 'description',
        content:
          'Araç kasko teklifi almak için online kasko hesaplama (sorgulama) aracını kullanın, aracınıza en uygun kasko fiyatlarını saniyeler içerisinde karşılaştırın.'
      }
    ]
  },
  mixins: [filteredButtons],
  name: 'MotorInsurance',
  components: {
    Navbar,
    Header,
    GetQuote,
    categoryInfo,
    getPriceSection,
    Tables,
    appContractedInsuranceCompanies,
    frequentlyAskedQuestions,
    Footer
  },
  data () {
    return {
      insuranceType: QuotationType.INSURANCE,
      categoryInfo: MotorInsuranceData.categoryInfo,
      getPrice: MotorInsuranceData.getPrice,
      faqTitle: MotorInsuranceData.faqTitle,
      faqTitleDesc: MotorInsuranceData.faqTitleDesc,
      questions: MotorInsuranceData.questions,
      getPriceContent: {
        upper: {
          title: 'Teklif Formumuzu Doldurun',
          desc:
            'Doğru poliçeyi doğru fiyata bulmanıza yardımcı olmak için 20’den fazla araba sigortası şirketini karşılaştıracağız.'
        },
        middle: {
          title: 'Karşılaştırma Ekranını Kullanın',
          desc:
            'Size aralarından seçim yapabileceğiniz bir alıntı listesi göstereceğiz. Burada fiyatları görüntüleyebilir ve sizin için önemli olan özellikleri (teminatları) ekleyebilirsiniz.'
        },
        bottom: {
          title: 'Ödeme Ekranına Geçiş Yapın',
          desc:
            'En iyi kasko sigortasına karar verdikten sonra ödeme ekranına geçiş yapın, avantajlı taksit seçeneklerinden yararlanın. Araba sigortanız için en iyi fiyatı almanıza yardımcı olmak için buradayız.'
        }
      },
      formData: {
        description: {
          upperText: 'Doğru Poliçe, Doğru Fiyat',
          title: 'Araç Kasko Sigortası',
          bottomText: 'En İyi Kasko Hesaplama'
        },
        button: 'KASKO TEKLİFİ AL',
        plate: true,
        fullname: true,
        identity: true,
        email: true,
        phone: true,
        document: true,
        job: true
      },
      quoteCard: {
        title: 'Kasko Fiyatlarında Alokasko Avantajı',
        description:
          "Kasko primlerinde %60'a varan tasarruf sağlayabilirsiniz.",
        content: [
          {
            id: 1,
            icon: 'fas fa-file-alt',
            title: 'En İyi Kasko Kapsamı',
            desc:
              'Arabanızı korumaya yardımcı olacak en iyi teminatları seçin. Kasko kapsamınızı en doğru şekilde belirleyin.'
          },
          {
            id: 2,
            icon: 'fab fa-cc-visa',
            title: '20 Sigorta Şirketinden Fiyat',
            desc:
              "En iyi kasko şirketlerinin fiyatlarını karşılaştırmak için teklif alın, primlerden %60'a varan tasarruf sağlayın."
          },
          {
            id: 3,
            icon: 'fas fa-clipboard-check',
            title: 'İndirimler',
            desc:
              'Kasko indirimlerine göz atarak araba sigortasından nasıl tasarruf sağlayacağınızı öğrenin. Taksit seçeneklerinden yararlanın.'
          },
          {
            id: 4,
            icon: 'fas fa-users-cog',
            title: 'Uzman Desteği',
            desc:
              'Kasko sigortası söz konusu olduğunda, birçok seçeneğiniz var. Alokasko uzmanları, doğru kapsamı bulmanıza yardımcı olabilir.  En doğru teminatlarla en uygun fiyatları alabilmeniz için uzmanlarımız 7/24 yanınızdadır.'
          }
        ]
      }
    }
  },
  mounted () {
    this.filterButtons('Kasko Sigortası')
  }
}
</script>
<style lang="scss">
@import '@/css/app.scss';
</style>
